'use client'

import * as React from 'react'
import type { SceneShelfSemanticName, SceneProductCardData, PriceData, ButtonFunctionType } from './types.js'

/**
 * SceneShelf Context 值类型
 */
export interface SceneShelfContextValue {
  /** 是否展示标签 */
  showTags?: boolean
  /** 是否展示原价 */
  showOriginalPrice?: boolean
  /** 语义化类名 */
  classNames?: Partial<Record<SceneShelfSemanticName, string>>
  /** 选中的产品 ID 集合 */
  selectedIds: Set<string>
  /** 选中的产品列表 */
  selectedProducts: SceneProductCardData[]
  /** 选中状态变化回调 */
  onSelectChange: (selected: boolean, product: SceneProductCardData) => void
  /** 了解更多回调 */
  onLearnMore?: (selectedProducts: SceneProductCardData[]) => void | Promise<void>
  /** 立即购买回调 */
  onShopNow?: (selectedProducts: SceneProductCardData[]) => void | Promise<void>
  /** 添加到购物车回调 */
  onAddToCart?: (selectedProducts: SceneProductCardData[]) => void | Promise<void>
  /** 主要按钮文本 */
  primaryButtonText?: string
  /** 主要按钮功能类型 */
  primaryButtonFun?: ButtonFunctionType
  /** 次要按钮文本 */
  secondaryButtonText?: string
  /** 次要按钮功能类型 */
  secondaryButtonFun?: ButtonFunctionType
  /** 总价标签 */
  totalPriceLabel?: string
  /** 当前总价 */
  totalCurrentPrice?: PriceData
  /** 原总价 */
  totalOriginalPrice?: PriceData
}

const SceneShelfContext = React.createContext<SceneShelfContextValue | null>(null)

/**
 * 获取 SceneShelf Context
 * @returns Context 值，如果在 Root 外使用则返回 null
 */
export function useSceneShelfContext() {
  return React.useContext(SceneShelfContext)
}

export { SceneShelfContext }
